import styled from "styled-components";
import React from "react";
import {useTranslation} from "react-i18next";

const LineMeaningContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    margin-bottom: 40px;
    font-family: MapfreText-Light;

    .line-row {
        display: flex;
        flex-direction: row;
        flex: 1 1 auto;
        margin-bottom: 10px;
    }

    .line-column {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
`;

const Line: React.FC<{lineColor?: string, dashed?: boolean}> = ({lineColor = '#fff', dashed= false}) => {

    return(
        <div style={{ margin: 'auto 0', marginRight: 10}}>
            <div style={{flex: 1}} />
            <div style={{flex: 0, borderTop: `4px ${dashed ? 'dashed' : 'solid'} ${lineColor}`, width: 30}}/>
            <div style={{flex: 1}} />
        </div>
    )
};

const LineMeaningComponent: React.FC = () => {
    const {t} = useTranslation();

    return(
        <LineMeaningContainer>
            <div className='line-column'>
                <div className='line-row'>
                    <Line lineColor={'#00A7FF'}/>
                    <div>{ t('latamBranchConcentration.legend.total') }</div>
                </div>
                <div className='line-row'>
                    <Line lineColor={'#00A7FF'} dashed={true}/>
                    <div>{ t('latamBranchConcentration.legend.totalAjust') }</div>
                </div>
            </div>

            <div className='line-column'>
                <div className='line-row'>
                    <Line lineColor={'#F44E3F'}/>
                    <div>{ t('latamBranchConcentration.legend.noLife') }</div>
                </div>
                <div className='line-row'>
                    <Line lineColor={'#F44E3F'} dashed={true}/>
                    <div>{ t('latamBranchConcentration.legend.noLifeAjust') }</div>
                </div>
            </div>

            <div className='line-column'>
                <div className='line-row'>
                    <Line lineColor={'#00D54A'}/>
                    <div>{ t('latamBranchConcentration.legend.life') }</div>
                </div>
                <div className='line-row'>
                    <Line lineColor={'#00D54A'} dashed={true}/>
                    <div>{ t('latamBranchConcentration.legend.lifeAjust') }</div>
                </div>
            </div>
        </LineMeaningContainer>
    )
};

export default LineMeaningComponent;
